import type { IWebNotification } from '../../api/domain';
import type { IRootState } from '../root-reducer';

export const getWebNotifications = (state: IRootState): IWebNotification[] => state.notificationsApi.webNotifications;
export const getWebNotificationsCount = (state: IRootState): number => state.notificationsApi.totalNotificationCount;
